import { render } from "./OpenLeadsView.vue?vue&type=template&id=2ac32027"
import script from "./OpenLeadsView.vue?vue&type=script&lang=js"
export * from "./OpenLeadsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__